import { moveToFulfilled, update } from '@ms/yammer-data-support';
import { CampaignState } from '@ms/yammer-graphql';
import { Reducer } from 'redux';

import {
  AllCampaignsLoadFulfilledAction,
  CampaignsListLoadMoreFulfilledAction,
} from '../../domains/allCampaigns/actions.types';
import { CampaignCreateFulfilledAction } from '../../domains/campaignCreation/actions.types';
import { CampaignDeleteFulfilledAction } from '../../domains/campaignDeletion/actions.types';
import { CampaignEditFulfilledAction, CampaignPublishFulfilledAction } from '../../domains/campaignEdit/actions.types';
import {
  CampaignFollowFulfilledAction,
  CampaignUnfollowFulfilledAction,
} from '../../domains/campaignFollowing/actions.types';
import { CampaignSashAddFulfilledAction } from '../../domains/campaignSash/addSashActions.types';
import { CampaignSashRemoveFulfilledAction } from '../../domains/campaignSash/removeSashActions.types';
import { CampaignTopContentCreatorsLoadFulfilledAction } from '../../domains/campaignTopContentCreators/actions.types';
import { CampaignTopThreadsLoadFulfilledAction } from '../../domains/campaignTopThreads/actions.types';
import { CampaignLoadFulfilledAction } from '../../domains/campaigns/actions.types';
import { CreateEventFulfilledAction } from '../../domains/createEvent/actions.types';
import { CuratedThreadListLoadAction } from '../../domains/curatedThreadList/actions.types';
import { DelegationTeamsLoadFulfilledAction } from '../../domains/delegation/actions.types';
import { EditEventFulfilledAction } from '../../domains/editEvent/actions.types';
import { EmployeesTopThreadsLoadFulfilledAction } from '../../domains/employeesTopThreads/actions.types';
import { EventLoadByBroadcastIdFulfilledAction } from '../../domains/eventLoadByBroadcastId/actions.types';
import {
  FeedLoadFulfilledAction,
  FeedLoadNewerThreadsFulfilledAction,
  FeedLoadOlderThreadsFulfilledAction,
} from '../../domains/feedLoad/actions.types';
import { GroupAddUserByEmailFulfilledAction } from '../../domains/groupAddRemoveUser/addUserByEmailActions.types';
import {
  GroupMemberPanelsLoadFulfilledAction,
  GroupMemberPanelsLoadMoreFulfilledAction,
} from '../../domains/groupMemberPanels/actions.types';
import { GroupMemberSearchLoadFulfilledAction } from '../../domains/groupMemberSearch/actions.types';
import { GroupPublisherSettingsFulfilledAction } from '../../domains/groupPublisherSettings/actions.types';
import { GroupSidebarLoadFulfilledAction } from '../../domains/groupSidebarLoad/actions.types';
import {
  GroupSuggestedMembersLoadAction,
  GroupSuggestedMembersLoadMoreAction,
} from '../../domains/groupSuggestedMembers/actions.types';
import { GroupCreateFulfilledAction, GroupEditFulfilledAction } from '../../domains/groups/actions.types';
import { GroupsMembersLoadFulfilledAction } from '../../domains/groupsMembers/actions.types';
import {
  LeaderLoadFulfilledAction,
  NewLeadersSuggestionsLoadFulfilledAction,
  UserConnectedLeadersListLoadFulfilledAction,
  UserConnectedLeadersListLoadMoreFulfilledAction,
  UserDirectAudienceLoadFulfilledAction,
  UserDirectAudienceLoadMoreFulfilledAction,
  UserFollowedLeadersListLoadFulfilledAction,
  UserFollowedLeadersListLoadMoreFulfilledAction,
  UserNetworkLeadersListLoadFulfilledAction,
  UserNetworkLeadersListLoadMoreFulfilledAction,
} from '../../domains/leadersManagement/actions.types';
import { LiveEventLoadByGroupIdFulfilledAction } from '../../domains/liveEventLoadByGroupId/actions.types';
import { MessageReactionsLoadFulfilledAction } from '../../domains/messageReactions/actions.types';
import {
  MessageUpvotesLoadFulfilledAction,
  MessageUpvotesLoadMoreFulfilledAction,
} from '../../domains/messageUpvoteLoad/actions.types';
import { MyLeaderSponsoredCampaignsLoadFulfilledAction } from '../../domains/myLeaderSponsoredCampaigns/loadActions.types';
import {
  NestedThreadDeepLinkSecondLevelLoadFulfilledAction,
  NestedThreadDeepLinkTopLevelLoadFulfilledAction,
  NestedThreadLoadFulfilledAction,
} from '../../domains/nestedThread/types';
import { NestedThreadListLoadFulfilledAction } from '../../domains/nestedThreadList/actions.types';
import { NetworkTopAnnouncementsLoadFulfilledAction } from '../../domains/networkTopAnnouncements/actions.types';
import { NetworkTopThreadStartersLoadAction } from '../../domains/networkTopThreadStarters/actions.types';
import { NetworkTopThreadsLoadFulfilledAction } from '../../domains/networkTopThreads/actions.types';
import { MarkAllNotificationsAsSeenFulfilledAction } from '../../domains/notificationFeeds/actions.types';
import { NotificationLoadMoreFulfilledAction } from '../../domains/notificationPaginations/actions.types';
import {
  OfficialGroupsLoadFulfilledAction,
  OfficialGroupsLoadMoreFulfilledAction,
} from '../../domains/officialGroups/actions.types';
import {
  ThreadPinToEventFeedFulfilledAction,
  ThreadPinToGroupFeedFulfilledAction,
  ThreadPinToTeamsMeetingFeedFulfilledAction,
  ThreadUnpinFromEventFeedFulfilledAction,
  ThreadUnpinFromGroupFeedFulfilledAction,
  ThreadUnpinFromTeamsMeetingFeedFulfilledAction,
} from '../../domains/pinnedThreads/actions.types';
import {
  PublishDirectMessageFulfilledAction,
  PublishEditMessageFulfilledAction,
  PublishEventMessageFulfilledAction,
  PublishGroupMessageFulfilledAction,
  PublishPollMessageFulfilledAction,
  PublishPraiseMessageFulfilledAction,
  PublishReplyMessageFulfilledAction,
  PublishTeamsMeetingMessageFulfilledAction,
  PublishUserMessageFulfilledAction,
  PublishUserMomentMessageFulfilledAction,
  PublishUserPollMessageFulfilledAction,
  PublishUserPraiseMessageFulfilledAction,
} from '../../domains/publishers/actions.types';
import {
  RecommendedGroupsLoadFulfilledAction,
  RecommendedGroupsLoadMoreFulfilledAction,
} from '../../domains/recommendedGroups/actions.types';
import { SearchLoadFulfilledAction, SearchLoadMoreFulfilledAction } from '../../domains/searches/actions.types';
import {
  SecondLevelRepliesLoadLastFulfilledAction,
  SecondLevelRepliesLoadNextFulfilledAction,
  SecondLevelRepliesLoadPreviousFulfilledAction,
} from '../../domains/secondLevelReplies/actions.types';
import { SessionLoadCurrentUserFulfilledAction } from '../../domains/sessionLoadCurrentUser/actions.types';
import { SuggestedActionsLoadFulfilledAction } from '../../domains/suggestedActions/actions.types';
import {
  SuggestedGroupsLoadFulfilledAction,
  SuggestedGroupsLoadMoreFulfilledAction,
} from '../../domains/suggestedGroups/actions.types';
import {
  SuggestedLeadersLoadFulfilledAction,
  SuggestedLeadersLoadMoreFulfilledAction,
} from '../../domains/suggestedLeaders/actions.types';
import { SuggestedMyLeaderGroupsLoadFulfilledAction } from '../../domains/suggestedMyLeaderGroups/actions.types';
import {
  SuggestedUsersLoadFulfilledAction,
  SuggestedUsersLoadMoreFulfilledAction,
} from '../../domains/suggestedUsers/actions.types';
import { TeamsMeetingLoadFulfilledAction } from '../../domains/teamsMeetingLoad/actions.types';
import { TeamsMeetingsByOrganizerFulfilledAction } from '../../domains/teamsMeetingsByOrganizer/actions.types';
import { ThreadExtendedActivitySharesLoadFulfilledAction } from '../../domains/threadExtendedActivityShares/actions.types';
import { ThreadExtendedActivityTopRepliesLoadFulfilledAction } from '../../domains/threadExtendedActivityTopReplies/actions.types';
import {
  ThreadLoadFulfilledAction,
  ThreadLoadNewerRepliesFulfilledAction,
  ThreadLoadOlderRepliesFulfilledAction,
} from '../../domains/threadLoad/actions.types';
import { ThreadSharesLoadFulfilledAction } from '../../domains/threadShares/actions.types';
import {
  TopLevelRepliesLoadInitialFulfilledAction,
  TopLevelRepliesLoadLastFulfilledAction,
  TopLevelRepliesLoadNextFulfilledAction,
  TopLevelRepliesLoadPreviousFulfilledAction,
} from '../../domains/topLevelReplies/actions.types';
import { TopicFollowersLoadFulfilledAction } from '../../domains/topicFollowers/loadActions.types';
import { TopicFollowersLoadMoreFulfilledAction } from '../../domains/topicFollowers/paginateActions.types';
import { TrendingCampaignsLoadFulfilledAction } from '../../domains/trendingCampaigns/loadActions.types';
import { TypeaheadFulfilledAction } from '../../domains/typeahead/actions.types';
import { UserFollowedByLoadFulfilledAction } from '../../domains/userFollowedBy/actions.types';
import { UserFollowedUsersLoadFulfilledAction } from '../../domains/userFollowedUsers/actions.types';
import { UserHeaderLoadFulfilledAction } from '../../domains/userHeaderLoad/actions.types';
import { UserInsightsInfluenceLoadFulfilledAction } from '../../domains/userInsightsInfluences/actions.types';
import { UserLoadFulfilledAction } from '../../domains/userLoad/actions.types';

import { Users } from './types';

export type UserAction =
  | CampaignEditFulfilledAction
  | CampaignPublishFulfilledAction
  | CampaignDeleteFulfilledAction
  | CampaignTopContentCreatorsLoadFulfilledAction
  | CampaignSashAddFulfilledAction
  | CampaignSashRemoveFulfilledAction
  | CreateEventFulfilledAction
  | EditEventFulfilledAction
  | EventLoadByBroadcastIdFulfilledAction
  | FeedLoadFulfilledAction
  | FeedLoadNewerThreadsFulfilledAction
  | FeedLoadOlderThreadsFulfilledAction
  | GroupSuggestedMembersLoadAction
  | GroupSuggestedMembersLoadMoreAction
  | ThreadExtendedActivityTopRepliesLoadFulfilledAction
  | ThreadExtendedActivitySharesLoadFulfilledAction
  | ThreadLoadFulfilledAction
  | ThreadLoadNewerRepliesFulfilledAction
  | ThreadLoadOlderRepliesFulfilledAction
  | ThreadPinToEventFeedFulfilledAction
  | ThreadPinToGroupFeedFulfilledAction
  | ThreadPinToTeamsMeetingFeedFulfilledAction
  | ThreadUnpinFromEventFeedFulfilledAction
  | ThreadUnpinFromGroupFeedFulfilledAction
  | ThreadUnpinFromTeamsMeetingFeedFulfilledAction
  | GroupSidebarLoadFulfilledAction
  | GroupsMembersLoadFulfilledAction
  | UserHeaderLoadFulfilledAction
  | LiveEventLoadByGroupIdFulfilledAction
  | PublishEventMessageFulfilledAction
  | PublishGroupMessageFulfilledAction
  | PublishUserMessageFulfilledAction
  | PublishUserMomentMessageFulfilledAction
  | PublishUserPollMessageFulfilledAction
  | PublishUserPraiseMessageFulfilledAction
  | PublishDirectMessageFulfilledAction
  | PublishEditMessageFulfilledAction
  | PublishReplyMessageFulfilledAction
  | PublishPollMessageFulfilledAction
  | PublishPraiseMessageFulfilledAction
  | PublishTeamsMeetingMessageFulfilledAction
  | TypeaheadFulfilledAction
  | SearchLoadFulfilledAction
  | SearchLoadMoreFulfilledAction
  | SessionLoadCurrentUserFulfilledAction
  | UserLoadFulfilledAction
  | UserFollowedByLoadFulfilledAction
  | UserFollowedUsersLoadFulfilledAction
  | UserInsightsInfluenceLoadFulfilledAction
  | MessageReactionsLoadFulfilledAction
  | GroupMemberSearchLoadFulfilledAction
  | MarkAllNotificationsAsSeenFulfilledAction
  | NetworkTopAnnouncementsLoadFulfilledAction
  | NetworkTopThreadStartersLoadAction
  | NotificationLoadMoreFulfilledAction
  | GroupMemberPanelsLoadFulfilledAction
  | GroupMemberPanelsLoadMoreFulfilledAction
  | NestedThreadLoadFulfilledAction
  | NestedThreadDeepLinkTopLevelLoadFulfilledAction
  | NestedThreadDeepLinkSecondLevelLoadFulfilledAction
  | NestedThreadListLoadFulfilledAction
  | TeamsMeetingLoadFulfilledAction
  | TeamsMeetingsByOrganizerFulfilledAction
  | TopLevelRepliesLoadInitialFulfilledAction
  | TopLevelRepliesLoadLastFulfilledAction
  | TopLevelRepliesLoadPreviousFulfilledAction
  | TopLevelRepliesLoadNextFulfilledAction
  | SecondLevelRepliesLoadPreviousFulfilledAction
  | SecondLevelRepliesLoadNextFulfilledAction
  | GroupPublisherSettingsFulfilledAction
  | GroupCreateFulfilledAction
  | GroupEditFulfilledAction
  | DelegationTeamsLoadFulfilledAction
  | GroupAddUserByEmailFulfilledAction
  | RecommendedGroupsLoadFulfilledAction
  | RecommendedGroupsLoadMoreFulfilledAction
  | SuggestedActionsLoadFulfilledAction
  | SuggestedGroupsLoadFulfilledAction
  | SuggestedGroupsLoadMoreFulfilledAction
  | SuggestedLeadersLoadFulfilledAction
  | SuggestedLeadersLoadMoreFulfilledAction
  | SuggestedUsersLoadFulfilledAction
  | SuggestedUsersLoadMoreFulfilledAction
  | MessageUpvotesLoadFulfilledAction
  | MessageUpvotesLoadMoreFulfilledAction
  | SecondLevelRepliesLoadLastFulfilledAction
  | ThreadSharesLoadFulfilledAction
  | TopicFollowersLoadFulfilledAction
  | TopicFollowersLoadMoreFulfilledAction
  | UserConnectedLeadersListLoadFulfilledAction
  | UserConnectedLeadersListLoadMoreFulfilledAction
  | UserFollowedLeadersListLoadFulfilledAction
  | UserFollowedLeadersListLoadMoreFulfilledAction
  | UserNetworkLeadersListLoadFulfilledAction
  | UserDirectAudienceLoadFulfilledAction
  | UserNetworkLeadersListLoadMoreFulfilledAction
  | LeaderLoadFulfilledAction
  | UserDirectAudienceLoadMoreFulfilledAction
  | SuggestedMyLeaderGroupsLoadFulfilledAction
  | CampaignLoadFulfilledAction
  | AllCampaignsLoadFulfilledAction
  | CampaignsListLoadMoreFulfilledAction
  | CampaignTopThreadsLoadFulfilledAction
  | MyLeaderSponsoredCampaignsLoadFulfilledAction
  | EmployeesTopThreadsLoadFulfilledAction
  | OfficialGroupsLoadFulfilledAction
  | OfficialGroupsLoadMoreFulfilledAction
  | TrendingCampaignsLoadFulfilledAction
  | CampaignFollowFulfilledAction
  | CampaignUnfollowFulfilledAction
  | CampaignCreateFulfilledAction
  | NetworkTopThreadsLoadFulfilledAction
  | CuratedThreadListLoadAction
  | NewLeadersSuggestionsLoadFulfilledAction;

const initialState: Users = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

const addUserSash = (state: Users, { userId: id, entities }: CampaignSashAddFulfilledAction['payload']) => {
  const { campaignId: sashCampaignId, sashImageUrl } = entities.userSashes[id];

  return update(state, id, {
    sashCampaignId,
    sashImageUrl,
  });
};

const removeUserSash = (state: Users, id: string, campaignId: string) => {
  const user = state.fulfilled.byId[id];

  if (user && user.sashCampaignId && campaignId === user.sashCampaignId) {
    return update(state, id, {
      sashCampaignId: undefined,
      sashImageUrl: undefined,
    });
  }

  return state;
};

const removeEndCampaignSash = (
  state: Users,
  {
    id: campaignId,
    userId,
    entities,
  }: CampaignEditFulfilledAction['payload'] | CampaignPublishFulfilledAction['payload']
) => {
  const campaignReferences = entities.campaignReferences[campaignId];
  if (campaignReferences && campaignReferences.state === CampaignState.CLOSED) {
    return removeUserSash(state, userId, campaignId);
  }

  return state;
};

const unfollowCampaign = (
  state: Users,
  { userId, id: campaignId, entities }: CampaignUnfollowFulfilledAction['payload']
) => {
  const stateWithoutSash = removeUserSash(state, userId, campaignId);

  return moveToFulfilled(stateWithoutSash, entities.users);
};

// eslint-disable-next-line max-lines-per-function
const reducer: Reducer<Users, UserAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'CAMPAIGN.EDIT_FULFILLED':
      return removeEndCampaignSash(state, action.payload);
    case 'CAMPAIGN.PUBLISH_FULFILLED':
      return removeEndCampaignSash(state, action.payload);
    case 'CAMPAIGN.DELETE_FULFILLED':
      return removeUserSash(state, action.payload.userId, action.payload.campaignId);
    case 'CAMPAIGN.UNFOLLOW_FULFILLED':
      return unfollowCampaign(state, action.payload);
    case 'CAMPAIGN.SASH.ADD_FULFILLED':
      return addUserSash(state, action.payload);
    case 'CAMPAIGN.SASH.REMOVE_FULFILLED':
      return removeUserSash(state, action.payload.userId, action.payload.campaignId);
    case 'CAMPAIGN_TOP_THREADS.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'EVENT.LOAD_BY_BROADCAST_ID_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'USER.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'FEED.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'FEED.LOAD_NEWER_THREADS_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'FEED.LOAD_OLDER_THREADS_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'GROUP_SIDEBAR.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'GROUP_SUGGESTED_MEMBERS.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'GROUP_SUGGESTED_MEMBERS.LOAD_MORE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'GROUPS_MEMBERS.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'USER_HEADER.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'USER_FOLLOWED_BY.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'USER_FOLLOWED_USERS.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'USER_INSIGHTS_INFLUENCE.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'LIVE_EVENT.LOAD_BY_GROUP_ID_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'THREAD.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'THREAD.LOAD_NEWER_REPLIES_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'THREAD.LOAD_OLDER_REPLIES_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'THREAD.PIN_TO_EVENT_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'THREAD.PIN_TO_GROUP_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'THREAD.PIN_TO_TEAMS_MEETING_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'THREAD.UNPIN_FROM_EVENT_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'THREAD.UNPIN_FROM_GROUP_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'THREAD.UNPIN_FROM_TEAMS_MEETING_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'THREAD_EXTENDED_ACTIVITY_TOP_REPLIES.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'THREAD_EXTENDED_ACTIVITY_SHARES.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'PUBLISHER.PUBLISH_EVENT_MESSAGE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'PUBLISHER.PUBLISH_GROUP_MESSAGE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'PUBLISHER.PUBLISH_USER_MESSAGE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'PUBLISHER.PUBLISH_USER_MOMENT_MESSAGE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'PUBLISHER.PUBLISH_USER_POLL_MESSAGE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'PUBLISHER.PUBLISH_USER_PRAISE_MESSAGE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'PUBLISHER.PUBLISH_DIRECT_MESSAGE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'PUBLISHER.PUBLISH_EDIT_MESSAGE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'PUBLISHER.PUBLISH_REPLY_MESSAGE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'PUBLISHER.PUBLISH_POLL_MESSAGE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'PUBLISHER.PUBLISH_PRAISE_MESSAGE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'PUBLISHER.PUBLISH_TEAMS_MEETING_MESSAGE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'SEARCH.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'SEARCH.LOAD_MORE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'SESSION.LOAD_CURRENT_USER_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'TYPEAHEAD.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'TEAMS_MEETINGS_BY_ORGANIZER.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'TEAMS_MEETING.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'MESSAGE_REACTIONS.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'GROUP_MEMBER_SEARCH.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'MARK_ALL_NOTIFICATIONS_AS_SEEN.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'NOTIFICATION.LOAD_MORE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'GROUP_MEMBER_PANELS.LOAD_MORE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'GROUP_MEMBER_PANELS.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'CREATE_EVENT.FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'EDIT_EVENT.FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'NESTED_THREAD.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'NESTED_THREAD.LOAD_DEEP_LINK_TOP_LEVEL_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'NESTED_THREAD.LOAD_DEEP_LINK_SECOND_LEVEL_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'NESTED_THREAD_LIST.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'TOP_LEVEL_REPLIES.LOAD_INITIAL_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'TOP_LEVEL_REPLIES.LOAD_PREVIOUS_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'TOP_LEVEL_REPLIES.LOAD_NEXT_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'TOP_LEVEL_REPLIES.LOAD_LAST_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'SECOND_LEVEL_REPLIES.LOAD_PREVIOUS_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'SECOND_LEVEL_REPLIES.LOAD_NEXT_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'SECOND_LEVEL_REPLIES.LOAD_LAST_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'PUBLISHER.LOAD_GROUP_PUBLISHER_SETTINGS_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'GROUP.EDIT_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'DELEGATION_TEAMS.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'GROUP.ADD_USER_BY_EMAIL_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'RECOMMENDED_GROUPS.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'RECOMMENDED_GROUPS.LOAD_MORE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'SUGGESTED_ACTION.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'SUGGESTED_GROUPS.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'SUGGESTED_GROUPS.LOAD_MORE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'SUGGESTED_LEADERS.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'SUGGESTED_LEADERS.LOAD_MORE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'SUGGESTED_USERS.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'SUGGESTED_USERS.LOAD_MORE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'MESSAGE_UPVOTES.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'MESSAGE_UPVOTES.LOAD_MORE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'MY_LEADER_SPONSORED_CAMPAIGNS.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'NETWORK_TOP_ANNOUNCEMENTS.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'NETWORK_TOP_THREADS.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'NETWORK_TOP_THREAD_STARTERS.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'THREAD_SHARES.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'TOPIC_FOLLOWERS.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'TOPIC_FOLLOWERS.LOAD_MORE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'ALL_LEADERS_IN_USERS_NETWORK.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'CONNECTED_LEADERS.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'CONNECTED_LEADERS.LOAD_MORE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'FOLLOWED_LEADERS.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'FOLLOWED_LEADERS.LOAD_MORE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'USER_DIRECT_AUDIENCE.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'ALL_LEADERS_IN_USERS_NETWORK.LOAD_MORE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'LEADER.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'USER_DIRECT_AUDIENCE.LOAD_MORE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'SUGGESTED_MY_LEADER_GROUPS.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'CAMPAIGN_TOP_CONTENT_CREATORS.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'CAMPAIGN.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'CAMPAIGN.CREATE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'CAMPAIGN.FOLLOW_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'ALL_CAMPAIGNS.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'ALL_CAMPAIGNS.LOAD_MORE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'EMPLOYEES_TOP_THREADS.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'OFFICIAL_GROUPS.LOAD_FULFILLED':
    case 'OFFICIAL_GROUPS.LOAD_MORE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'TRENDING_CAMPAIGNS.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'CURATED_THREAD_LIST_LOAD.FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    case 'NEW_LEADERS_SUGGESTIONS.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.users);
    default:
      return state;
  }
};

export default reducer;
